// URL бекенду — береться з .env (REACT_APP_BACKEND_URL)
// Для локальної розробки: створіть .env.local з REACT_APP_BACKEND_URL=http://localhost:8082
export const BACKEND_URL =
    process.env.REACT_APP_BACKEND_URL || 'https://web-production-1585e.up.railway.app';

export const COMPANY_ADDRESS =
    'вул. Дністрова, 87, кв. 72, Старий Самбір, 82000, Львівська обл., Україна';

export const COMPANY_PHONES = [
    { number: '+380778966515', display: '+380 (77) 896-65-15' },
    { number: '+380759763545', display: '+380 (75) 976-35-45' },
    { number: '+380637656645', display: '+380 (63) 765-66-45' },
];

export const COMPANY_EMAIL = 'rvadym40@gmail.com';
